var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sale',{attrs:{"sale-id":this.$route.params.saleId,"customer-id":this.$route.params.customerId,"invoice-id":this.$route.params.invoiceId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }